import {
  POST_USER_LOGIN,
  POST_USER_LOGIN_SUCCESS,
  POST_USER_LOGIN_FAILED,
  DELETE_AUTH,
} from './authActionTypes';

const initialState = {
  loading: false,
  isError: false,
  success: false,
  errorMsg: false,
  token: false,
  update: false,
};

export default function authReducer (prevState = initialState, action) {
  switch (action.type) {
    case POST_USER_LOGIN:
      return {
        ...prevState,
        loading: true,
        success: false,
        errorMsg: false,
      };
    case POST_USER_LOGIN_SUCCESS:
      return {
        ...prevState,
        loading: false,
        success: true,
        token: action.payload.token,
        errorMsg: false,
      };
    case POST_USER_LOGIN_FAILED:
      return {
        ...prevState,
        loading: false,
        errorMsg: action.payload.errorMsg,
        token: false,
        succes: false,
      };
    case DELETE_AUTH:
      return {
        ...initialState,
      };
      case "UPDATE_ACTION":
        return{
          ...prevState,
          update: action.payload.update,
        }
    default:
      return prevState;
  }
};
